import { render, staticRenderFns } from "./xtxx_rj.vue?vue&type=template&id=5f18ef70&scoped=true&"
import script from "./xtxx_rj.vue?vue&type=script&lang=js&"
export * from "./xtxx_rj.vue?vue&type=script&lang=js&"
import style0 from "./xtxx_rj.vue?vue&type=style&index=0&id=5f18ef70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f18ef70",
  null
  
)

export default component.exports